
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import productOptionMixin from '@/mixin/productOptionStatus'
import currencyOptionMixin from '@/mixin/currencyOption'
import orderDateOptionMixin from '@/mixin/orderDateOption'
import {
  orderAntExport
  // setUnpaidOrder,
  // setPaidOrder,
} from '@/api/order/topupOrder'
import {
  getStatistics,
  antTopupList,
  changeOrderStatus
} from '@/api/order/topupOrder'
import { Form as ElForm } from 'element-ui'
import { AppModule } from '@/store/modules/app'
import pagination from '@/components/Pagination/index.vue'
import orderDetail from './components/topupOrderDetail.vue'
import { delObjEmptyKey } from '@/utils'
import { setOrderStatusRules } from '@/utils/rules'
import { checkNeedAudit, checkPermission } from '@/utils/permission'
import { operationMessage } from '@/utils/message'
import { getCurrentDate, dateToSeconds } from '@/utils/dateTime'
import PicsUploader from '@/components/PicsUploader/index.vue'
import depositBatchNotify from './components/depositBatchNotify.vue'
import kick from './components/kickOut.vue'
import guijiInfo from './components/guiji.vue'
import zhiyaInfo from './components/zhiya.vue'

@Component({
  name: 'depositList',
  components: {
    pagination,
    orderDetail,
    PicsUploader,
    depositBatchNotify,
    kick,
    guijiInfo,
    zhiyaInfo
  }
})
export default class extends mixins(
  productOptionMixin,
  currencyOptionMixin,
  orderDateOptionMixin
) {
  get language() {
    return AppModule.language
  }
  private data_source: string = 'simple_order'
  queryForm: any = {
    upstream_remarks: null,
    ant_username: null,
    order_number: null,
    status: null,
    product: null,
    min_amount: '',
    max_amount: '',
    min_request_amount: '',
    max_request_amount: '',
    start_time: null,
    end_time: null,
    notify_start_time: null,
    notify_end_time: null,
    product_name: null,
    product_account_name: null,
    success_start_time: null,
    success_end_time: null
  }

  private amountType: string = 'Paid Amount'
  private statusList: any[] = []
  private instruction: any[] = []
  private orderStatusList: any[] = []
  private upstreamStatusList: any[] = []
  private sendLoading: boolean = false
  private orderList: any[] = []
  private listLoading: Boolean = false
  private totalData: any = {}
  // private total = {}
  private total = 0
  private listQuery = {
    page: 1,
    limit: 20
  }
  private dialogVisible: boolean = false
  private setForm: any = {}
  private payTime: any = ''
  private selectList: any[] = []
  private ordernumbers: any[] = []
  private dialogVisible1: boolean = false

  private rules = setOrderStatusRules
  private loading: boolean = false

  private currentOrdernumber: number | null = null
  private drawer: boolean = false

  // 归集设置
  private guijiVisible: boolean = false
  private openGuiJi() {
    this.guijiVisible = true
  }
  private closeGuiji() {
    this.guijiVisible = false
    this.hadleGetFilesListApi()
  }

  private zhiyaVisible: boolean = false
  private openZhiYa() {
    this.zhiyaVisible = true
  }
  private closeZhiya() {
    this.zhiyaVisible = false
    this.hadleGetFilesListApi()
  }

  // 跳转地址
  private jumpAddress(row, type) {
    if (type === 'trc20') {
      window.open(`https://tronscan.io/#/address/${row}/transfers`)
    } else if (type === 'erc20') {
      window.open(`https://etherscan.io/address/${row}`)
    }
  }
  private hashJump(row) {
    if (row.coin_type === 'trc20') {
      window.open(
        `https://tronscan.io/#/transaction/${row.upstream_ordernumber}`
      )
    } else if (row.coin_type === 'erc20') {
      window.open(`https://etherscan.io/tx/${row.upstream_ordernumber}`)
    }
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      if (this.queryForm.currency) {
        delete this.queryForm.currency
      }
      const params: any = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await antTopupList(params).then((res: any) => {
        // this.orderList = res.results
        this.orderList = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private isDisabled(row, index) {
    return row.status === 1 && row.notify_status !== 1
  }

  private handleSelectionChange(list) {
    this.selectList = list
  }

  private changeAmount() {
    this.queryForm.min_request_amount = null
    this.queryForm.max_request_amount = null
    this.queryForm.min_amount = null
    this.queryForm.max_amount = null
  }

  // 上传图片
  private getPicList(fileList: any) {
    this.setForm.attach = fileList.map((item: any) => {
      if (item.response) {
        return item.response.file_path
      } else {
        return item.url
      }
    })
  }

  private isCanSet(info: any) {
    return info.status === 1
      ? checkPermission('change_paid_deposit_order_status')
      : checkPermission('change_unpaid_deposit_order_status')
  }

  private openDialog(info: any) {
    this.setForm = {
      ...info,
      oldStatus: info.status,
      status: null
    }
    this.dialogVisible = true
  }

  // 批量发送订单回调
  private openDialog1() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      this.ordernumbers.push(this.selectList[i].ordernumber)
    }
    this.dialogVisible1 = true
  }

  private closeDialog() {
    this.dialogVisible = false
    this.opnekickOut = false
    this.hadleGetFilesListApi()
  }

  private closeDialog1() {
    this.dialogVisible1 = false
    this.hadleGetFilesListApi()
  }

  // 踢出队列
  private opnekickOut: boolean = false
  private openKickOut() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (this.selectList[i].is_in_queue !== null) {
        this.ordernumbers.push(this.selectList[i].ordernumber)
      }
    }
    this.opnekickOut = true
  }

  @Watch('val', { immediate: true })
  private getTimeStamp(val) {
    this.setForm.timeStamp = dateToSeconds(val)
  }

  private immediUpdate(e) {
    this.$nextTick(() => {
      if (e == null) {
        this.setForm.timeStamp = ''
      }
    })
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private async setOrderStatus() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        let { ordernumber, status, remarks, attach, upstream_ordernumber } =
          this.setForm
        // if (this.setForm.paid_time === '') {
        //   paid_time = ''
        // }
        const data: any = {}
        data.name = this.setForm.ordernumber
        data.body = {
          status,
          remarks,
          attach,
          upstream_ordernumber
        }
        try {
          // if (this.setForm.oldStatus === 0) {
          //   // 未支付=>支付
          //   await setUnpaidOrder(data).then(() => {
          //     operationMessage(
          //       checkNeedAudit('change_unpaid_deposit_order_status') !==
          //         undefined
          //     )
          //     this.flagStr()
          //     this.loading = false
          //   })
          // } else {
          //   await setPaidOrder(data).then(() => {
          //     operationMessage(
          //       checkNeedAudit('change_paid_deposit_order_status') !== undefined
          //     )
          //     this.flagStr()
          //     this.loading = false
          //   })
          // }
          await changeOrderStatus(data).then(() => {
            this.flagStr()
            this.loading = false
          })
          this.closeDialog()
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  private openDrawer(row: any) {
    this.currentOrdernumber = row.ordernumber
    this.drawer = true
  }

  private closeDrawer(isManual: boolean = false) {
    if (isManual) {
      this.drawer = false
    }
    this.currentOrdernumber = null
    this.hadleGetFilesListApi()
  }
  private versionChange(v) {
    this.queryForm.data_source = v
    this.hadleGetFilesListApi()
    this.depositOrderStatistical()
  }

  private reset() {
    this.queryForm = {
      upstream_remarks: null,
      ant_username: null,
      order_number: null,
      start_time: null,
      end_time: null,
      status: null,
      product: null,
      notify_start_time: null,
      notify_end_time: null,
      min_amount: '',
      max_amount: '',
      min_request_amount: '',
      max_request_amount: '',
      success_start_time: null,
      success_end_time: null
    }
    this.dateType = 'Created Time'
    this.date = getCurrentDate()
    this.notifyDate = getCurrentDate()
    this.successDate = getCurrentDate()
    this.currentPage = 1
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
      this.depositOrderStatistical()
    })
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
    this.depositOrderStatistical()
  }

  // 入金订单统计
  private async depositOrderStatistical() {
    try {
      if (this.queryForm.currency) {
        delete this.queryForm.currency
      }
      let data: any = {
        ...this.queryForm
      }
      await getStatistics(data).then((res: any) => {
        this.totalData = res
      })
    } catch (e) {}
  }

  private async exportData() {
    try {
      this.sendLoading = true
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await orderAntExport(data).then(() => {
        if (this.language === 'en') {
          this.$message({
            message: 'The form has been sent to your mailbox, please check it!',
            type: 'success'
          })
        }
        if (this.language === 'zh_cn') {
          this.$message({
            message: '表格已发送到您的邮箱，请查收!',
            type: 'success'
          })
        }
        if (this.language === 'zh_tw') {
          this.$message({
            message: '表格已發送到您的郵箱，請查收!',
            type: 'success'
          })
        }
        this.sendLoading = false
      })
    } catch (e) {
      this.sendLoading = false
      this.$message({
        message: 'Export failure!',
        type: 'error'
      })
    }
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  private async init() {
    this.orderStatusList = await AppModule.GetOrderStatusList()
    this.upstreamStatusList = await AppModule.GetUpstreamStatusList()
    await AppModule.GetConstant().then((res: any) => {
      this.statusList = res.IN_ORDER_STATUS_CHOICES
    })
    this.hadleGetFilesListApi()
    this.depositOrderStatistical()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.topupOrder`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }

  mounted() {
    // (window as any).jumpAddress = this.jumpAddress
    this.init()
  }
}
